module.exports = __webpack_public_path__ + "static/locator-6abbad59bf0c6b951fceb05adca3b587.jpg";